module.exports = __webpack_public_path__ + "img/icon_benefit_04_w.7c5ab1c2.svg";